import { render, staticRenderFns } from "./RecordLog.vue?vue&type=template&id=c8d36cac&scoped=true&"
import script from "./RecordLog.vue?vue&type=script&lang=js&"
export * from "./RecordLog.vue?vue&type=script&lang=js&"
import style0 from "./RecordLog.vue?vue&type=style&index=0&id=c8d36cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d36cac",
  null
  
)

export default component.exports